module.exports = {
      id: "longrightarrow-usage",
      viewBox: "0 0 512 512",
      url: __webpack_public_path__ + "svg-sprite-cba8a2d7d36c4565ac7b4e175a8fc907.svg#longrightarrow",
      toString: function () {
        return this.url;
      }
    }